<svelte:options tag="tv2no-chat-element" />

<script>
  import { onMount } from 'svelte';
  import { channel as chatChannel, Chat } from 'tv2no-chat';
  import { getApplicationConfig, getHlsUrls } from '../../Api/videoApi';
  import { getFirebaseApp } from '../../Api/firebase';
  import { getCategories, getIdTokenResult, onAuthStateChanged } from '../../Api/api';
  import { applicationConfig, categories, firebaseApp, user } from '../../Store/store';
  import config from '../../config';

  export let chatid;
  export let postertitle = 'Livechat foregår nå';
  export let posterlinktext = 'Bli med i chatten';

  let hlsURL;
  let isApp;

  // Init app
  const initHlsUrls = async () => {
    const urls = await getHlsUrls();
    hlsURL = urls.hlsURL;
  };

  const initConfig = async () => {
    const config = await getApplicationConfig();
    applicationConfig.set(config);
  };

  const getFirebaseConfig = async () => {
    const app = await getFirebaseApp();
    if (app) {
      firebaseApp.set(app);
    }
  };

  $: isApp = window?.location.search.includes('mode=app');

  onMount(async () => {
    if (isApp) {
      return null;
    }

    await getFirebaseConfig();
    await initConfig();
    await initHlsUrls();

    const channelCategories = await getCategories();
    const allCategories = [
      { type: 'all', displayName: 'Alle', sortOrder: 0 },
      ...channelCategories,
    ].sort((a, b) => a.sortOrder - b.sortOrder);
    categories.set(allCategories);

    await onAuthStateChanged(async (loggedInUser) => {
      if (!loggedInUser) {
        user.set(null);
      } else {
        getIdTokenResult().then((token) => {
          if (token) {
            if (['admin', 'super-admin'].includes(token.claims.level)) {
              user.set(loggedInUser);
            }
          }
        });
      }
    });
  });
</script>

{#if !isApp}
  <div class="chat-embed">
    <div class="chat">
      {#if $firebaseApp && $applicationConfig.playURL}
        <Chat
          id={chatid}
          app={$firebaseApp}
          websocketURL={$applicationConfig.playURL}
          {hlsURL}
          basePath={config.baseUrl}
        >
          <div class="app-nav" slot="mobile_navigation">
            <div class="content">
              <h1>{$chatChannel ? $chatChannel.name : 'TV2 Chat'}</h1>
            </div>
          </div>
        </Chat>
      {/if}
    </div>
  </div>
{:else}
  <div class="applink" style="background-image: url({config.baseUrl}/assets/chat-bg.png)">
    <div class="applink-image">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="52"
        ><path
          d="M51.667 0H8.333A8.333 8.333 0 0 0 0 8.333v25a8.333 8.333 0 0 0 8.333 8.334h5v10H20l10-10h21.667A8.333 8.333 0 0 0 60 33.333v-25A8.333 8.333 0 0 0 51.667 0ZM15.833 25a4.167 4.167 0 1 1 0-8.333 4.167 4.167 0 0 1 0 8.333Zm15 0a4.167 4.167 0 1 1 0-8.333 4.167 4.167 0 0 1 0 8.333Zm15 0a4.167 4.167 0 1 1 0-8.333 4.167 4.167 0 0 1 0 8.333Z"
        /></svg
      >
    </div>

    <div class="applink-text">{postertitle}</div>
    <a href="{config.baseUrl}/chat/{chatid}" class="applink-link">{posterlinktext}</a>
  </div>
{/if}

<style src="./embedChat.scss">
</style>
